module.exports = __webpack_public_path__ + "media/harp.f259743e.ogg";